import * as React from 'react';
import InlineError from '../InlineError';
import { AxiosError } from 'axios';

interface ProviderApiErrorProps {
    error?: Error | null;
    centered?: boolean;
    styles?: React.CSSProperties;
}

const ProviderApiError: React.FC<ProviderApiErrorProps> = ({ centered = false, error, styles }) => {
    const axiosError = error as AxiosError;

    return axiosError?.response?.data && Array.isArray(axiosError.response.data)
        ? axiosError.response.data[0]
              .split(',')
              .map((message: string, index: number) => (
                  <InlineError key={index} message={message} centered={centered} styles={styles} />
              ))
        : null;
};

export default ProviderApiError;
